// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Panel} from '../../../comp/panel';
import {Promotions_table} from '../../../features/promotions_table';

export function Promo(){
    return <Panel><Promotions_table/></Panel>;
}
